import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalService } from '../services/modal.service';

@Component({
  selector: 'online-app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  displayStyle = 'none';
  deleteDisplayStyle = 'none';
  preventAddContactDisplayStyle = 'none';

  confirmMessage: string;
  isConfirmModal: boolean = false;
  isCopyModal: boolean = false;
  isCopySAModal: boolean = false;

  @ViewChild('focusChange') elChange: ElementRef;
  @ViewChild('focusDelete') elDelete: ElementRef;
  @ViewChild('focusContact') elContact: ElementRef;
  @ViewChild('focusConfirm') elConfirm: ElementRef;
  constructor(private modalService: ModalService) { }

  ngOnInit() {

    this.modalService.isModalVisible.subscribe(isModalVisible => {
      this.displayStyle = isModalVisible ? 'block' : 'none';
      setTimeout(() => {
        this.elChange.nativeElement.focus();
      }, 100);
    });

    this.modalService.isDeleteModalVisible.subscribe(isDeleteModalVisible => {
      this.deleteDisplayStyle = isDeleteModalVisible ? 'block' : 'none';
      setTimeout(() => {
        this.elDelete.nativeElement.focus();
      }, 100);
    });

    this.modalService.allowAddContactModalVisible.subscribe(allowAddContactModalVisible => {
      this.preventAddContactDisplayStyle = allowAddContactModalVisible ? 'block' : 'none';
      setTimeout(() => {
        this.elContact.nativeElement.focus();
      }, 100);
    });

    this.modalService.confirmModalVisible.subscribe(isConfirmModal => {
      this.confirmMessage = this.modalService.confirmMessage;
      this.isConfirmModal = isConfirmModal;
      setTimeout(() => {
        this.elConfirm.nativeElement.focus();
      }, 100);
    });

    this.modalService.copyModalVisible.subscribe(isCopyModal => {
      this.isCopyModal = isCopyModal;
      setTimeout(() => {
        this.elConfirm.nativeElement.focus();
      }, 100);
    });

    this.modalService.copySAModalVisible.subscribe(isCopySAModal => {
      this.isCopySAModal = isCopySAModal;
      setTimeout(() => {
        this.elConfirm.nativeElement.focus();
      }, 100);
    });
  }

  addShowCSSClass(): boolean {
    return this.displayStyle === 'block';
  }

  addDeleteShowCSSClass(): boolean {
    return this.deleteDisplayStyle === 'block';
  }

  preventAddContactShowCSSClass(): boolean {
    return this.preventAddContactDisplayStyle === 'block';
  }

  discardChanges() {
    this.modalService.isModalVisible.next(false);
    this.modalService.stayOnThePage.next(true);
  }

  stay() {
    this.modalService.isModalVisible.next(false);
    this.modalService.stayOnThePage.next(false);
  }

  allowDelete() {
    // this.modalService.isDeleteModalVisible.next(false);
    this.modalService.hideDeleteModal();
    this.modalService.allowDelete.next(true);

  }

  preventDelete() {
    // this.modalService.isDeleteModalVisible.next(false);
    this.modalService.hideDeleteModal();
    this.modalService.allowDelete.next(false);
  }

  preventAddContact() {
    this.modalService.hideAllowAddContactModal();
    this.modalService.allowAddContactModalVisible.next(false);
  }

  confirm(isConfirm: boolean) {
    this.modalService.hideConfirmModal(isConfirm);
    this.isConfirmModal = false;
  }

  copy(isConfirm: string) {
    this.modalService.hideCopyModal(isConfirm);
    this.isCopyModal = false;
  }

  copySA(isConfirm: string) {
    this.modalService.hideCopySAModal(isConfirm);
    this.isCopySAModal = false;
  }

  closeCopySA() {
    this.isCopySAModal = false;
  }

}
